module.exports = __webpack_public_path__ + "img/ico_look.866397d7.svg";